import { type MCPServerInfo } from '../../types';

const GenaiToolboxOracleDBServer: MCPServerInfo = {
  serverId: 'GENAI_TOOLBOX_ORACLEDB',
  name: 'MCP Toolbox for Oracle Database',
  slug: 'genai-toolbox-oracledb',
  description:
    "Google's MCP Toolbox for Databases — Oracle DB prebuilt. Connect to Oracle Database or Oracle Autonomous Database (ADB) using the Model Context Protocol.",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/googleapis/genai-toolbox',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'ghcr.io/googleapis/genai-toolbox'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['oracleConnectionString', 'oracleUsername', 'oraclePassword'],
    properties: {
      oracleConnectionString: {
        type: 'string',
        description:
          'Easy Connect string for your Oracle instance (e.g. myhost.example.com:1521/myservice or for ADB: adb.us-ashburn-1.oraclecloud.com:1521/abc123_mydb_tp.adb.oraclecloud.com)',
        sensitive: false
      },
      oracleUsername: {
        type: 'string',
        description: 'Oracle database username',
        sensitive: false
      },
      oraclePassword: {
        type: 'string',
        description: 'Oracle database password',
        sensitive: true
      }
    }
  }
};

export default GenaiToolboxOracleDBServer;
